/**
 * Query keys for the Racing feature.
 *
 * Namespaced under a single root so a mutation can invalidate the whole feature with one call, or a
 * single race event when the change is local to it.
 */
export const raceKeys = {
  /** Every racing query. */
  all: ['racing'] as const,
  /** The public discovery list. */
  list: () => [...raceKeys.all, 'list'] as const,
  /** The calling organiser's own events. */
  mine: () => [...raceKeys.all, 'mine'] as const,
  /** One race event with everything attached. */
  event: (raceEventId: string) => [...raceKeys.all, 'event', raceEventId] as const,
  /** The calling user's organiser profile. */
  organizer: () => [...raceKeys.all, 'organizer'] as const,
};
